import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CategoriesService } from '../shared/category/categories.service';
import { ContractStructureFeaturesComponent } from '../contract-structure/features/contract-structure-features.component';
import { processResolver } from './process-resolver';

const log = new LoggingService();
export const ContractStructureRoute: Ng2StateDeclaration = {
    name: 'contractstructure',
    url: '/contractstructure',
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: ContractStructureFeaturesComponent
};
